
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import RecommendedCourses from "@/components/RecommendedCourses";
import RecommendedAccommodations from "@/components/RecommendedAccommodations";
import ServiceFeatures from "@/components/ServiceFeatures";
import BrandPhilosophy from "@/components/BrandPhilosophy";
import UserReviews from "@/components/UserReviews";
import FloatingChatButton from "@/components/FloatingChatButton";
import Footer from "@/components/Footer";
import { usePerformanceTracking } from "@/lib/performance-monitor";

const Index = () => {
  usePerformanceTracking('Index');

  return (
    <div className="min-h-screen bg-white pb-mobile-nav">
      <Header />
      <HeroSection />
      <RecommendedCourses />
      <RecommendedAccommodations />
      <ServiceFeatures />
      <BrandPhilosophy />
      <UserReviews />
      <FloatingChatButton />
      <Footer />
    </div>
  );
};

export default Index;
